import React, { useState } from 'react';
import validate from 'web-form-validator';
import { setDeepValue } from 'utils/objects';

export default (schema, formData) => (WrappedComponent) => {
  const Validator = (props) => {
    const [values, setValues] = useState(formData || {});
    const [errors, setErrors] = useState({});
    const [isValid, setIsValid] = useState(true);

    const onChangeHandler = (name, value) => {
      let clonedValues = { ...values };
      if (name.split('.').length > 1) {
        clonedValues = setDeepValue(Object.assign({}, clonedValues), name, value);
      } else {
        clonedValues[name] = value;
      }

      if (Object.prototype.hasOwnProperty.call(errors, name)) {
        delete errors[name];
      }

      setErrors(errors);
      setValues(clonedValues);
      setIsValid(Object.keys(errors).length === 0);
    };

    // Use this method to set values on componentWillMount
    // if user already entered some data before
    const setValuesData = (valuesData) => {
      typeof valuesData === 'object' && setValues(valuesData);
    };

    const setErrorsData = (errorsData = {}) => {
      const newErrors = { ...errors, ...errorsData };
      setErrors(newErrors);
    };

    const resetErrors = () => {
      setErrors({});
      setIsValid(true);
    };

    // User this methond on detele multiple errors e.g. ['password', 'passwordConfirmation']
    // to remove errors from all related inputs on changing the only one of them
    const deleteErrors = (names = []) => {
      names.forEach(name => (
        delete errors[name]
      ));
      setErrors(errors);
      setIsValid(Object.keys(errors).length === 0);
    };

    const validateForm = (customSchema = schema) => {
      const clonedValues = { ...values };
      // eslint-disable-next-line no-shadow
      const { errors, isValid } = validate(customSchema, clonedValues);
      setErrors(errors);
      setIsValid(isValid);
      return { isValid };
    };

    return (
      <WrappedComponent
        validator={{
          validate: validateForm,
          setValues: setValuesData,
          setErrors: setErrorsData,
          deleteErrors,
          resetErrors,
          onChangeHandler,
          values,
          errors,
          isValid,
        }}
        {...props}
      />
    );
  };

  return Validator || null;
};
